import * as React from 'react';
import '@patternfly/react-core/dist/styles/base.css';
import '@app/app.css';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AppLayout } from '@app/AppLayout/AppLayout';
import { AppRoutes } from '@app/routes';
import { RequireAdmin } from '@app/Auth/RequireAdmin';
import Login from '@app/Login/Login';
import useToken from '@app/Login/useToken';

const App: React.FunctionComponent = () => {
  const { token, setToken } = useToken();

  return (
    <Router>
      <Toaster position="top-right" />
      <Routes>
        <Route
          path="/*"
          element={
            !token ? (
              <Login setToken={setToken} />
            ) : (
              <RequireAdmin>
                <AppLayout>
                  <AppRoutes />
                </AppLayout>
              </RequireAdmin>
            )
          }
        />
      </Routes>
    </Router>
  );
};

export { App };
